'use client';
import { DEBUG } from '../constants';
export class Logger {
    static log(...args) {
        DEBUG && console.log(...args);
    }
    static error(...args) {
        DEBUG && console.error(...args);
    }
}
